import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { firebaseDB } from '../firebase/config';
import { Notification } from '../firebase/entities';

const useCreateNotification = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createNotification = async (entity: Notification) => {
    setLoading(true);
    setError(null);

    try {
      const usersCollection = collection(firebaseDB, 'notifications');
      await addDoc(usersCollection, {
        ...entity,
        read: false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
    } catch (err) {
      setError('Error creating notification');
    } finally {
      setLoading(false);
    }
  };

  return { createNotification, loading, error };
};

export default useCreateNotification;